import * as React from "react"
import * as PopoverPrimitive from "@radix-ui/react-popover"

import { cn } from "../../lib/utils"
import { Z_CLASS } from "../../lib/z-index"

/**
 * Overlay z-index scale — see lib/z-index.js for the full hierarchy:
 * popover/select/dropdown 102 → dialog 105 → sheet 110.
 * Use `elevated` on PopoverContent when the trigger lives inside a dialog.
 */

const Popover = PopoverPrimitive.Root

const PopoverTrigger = PopoverPrimitive.Trigger

const PopoverAnchor = PopoverPrimitive.Anchor

const PopoverContent = React.forwardRef(
  ({ className, align = "start", sideOffset = 4, collisionPadding = 16, elevated = false, ...props }, ref) => (
    <PopoverPrimitive.Portal>
      <PopoverPrimitive.Content
        ref={ref}
        align={align}
        sideOffset={sideOffset}
        collisionPadding={collisionPadding}
        className={cn(
          elevated ? Z_CLASS.POPOVER_IN_DIALOG : Z_CLASS.POPOVER,
          "w-popover-mobile max-w-[calc(100vw-2rem)] rounded-md border bg-popover dark:bg-gray-900 p-3 text-popover-foreground dark:text-white shadow-md outline-none data-[state=open]:animate-in data-[state=closed]:animate-out data-[state=closed]:fade-out-0 data-[state=open]:fade-in-0 data-[state=closed]:zoom-out-95 data-[state=open]:zoom-in-95 data-[side=bottom]:slide-in-from-top-2 data-[side=left]:slide-in-from-right-2 data-[side=right]:slide-in-from-left-2 data-[side=top]:slide-in-from-bottom-2 origin-[--radix-popover-content-transform-origin] md:w-72 md:p-2.5",
          className
        )}
        {...props}
      />
    </PopoverPrimitive.Portal>
  )
)
PopoverContent.displayName = PopoverPrimitive.Content.displayName

export { Popover, PopoverTrigger, PopoverContent, PopoverAnchor }
